<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="store(0)" novalidate>
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                    <h4 class="modal-title">{{ $t('follow_up') }}</h4>
                </div>
                <div class="modal-body">

                    <!-- Deal -->
                    <div class="modal_deal p_bottom_15">
                        <h5 class="m-t-0"><i class="fa-fw ti-user"></i> {{ $t('find_your_deal') }}</h5>
                        <pml-select-deals v-model="search" :exactDeal="exactDeal"></pml-select-deals>
                        <span class="error" v-if="errors['deal']">{{ errors['deal'][0] }}</span>
                    </div>

                    <!-- Task -->
                    <div class="modal_deal">
                        <div class="select_lead" v-if="!search">
                            <div class="d_table w_full h_full">
                                <div class="d_t_cell">
                                    <i class="fa fa-exclamation-triangle text-warning fa-3x"></i>
                                    <h4 class="t_uppercase"><b>{{ $t('select_a_deal') }}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['access_way_id']}">
                                <label>{{ $t('access_way') }}</label>
                                <pml-select v-model="record.access_way_id" :options="accessWays()"></pml-select>
                                <span class="error" v-if="errors['access_way_id']">{{ errors['access_way_id'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12" :class="{ 'has-error': errors['content'] }">
                                <label>{{ $t('comments') }} </label>
                                <textarea v-model="record.content" v-pml-autosize class="form-control" rows="5"></textarea>
                                <span class="error" v-if="errors['content']">{{ errors['content'][0] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-15 t_right">
                    <span class="btn btn-white pull-left btn_mobile_block" @click="goBack()">{{ $t('cancel') }}</span>
                    <a href="#" @click.prevent="store(1)" class="btn btn_green btn_mobile_block" :disabled="!search" v-pml-block="isSaving">{{ $t('save_and_go_to_deal') }}</a>
                    <button type="submit" class="btn btn-default btn_mobile_block" :disabled="!search" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { create } from 'services/follow-ups'
    import { isNull } from 'lodash'
    import bus from '@/utils/events/bus'

    export default {
        name: 'FollowUpsCreate',
        mixins: [ RoutedModals ],
        data () {
            return {
                exactDeal: null,
                search: null,
                isSaving: false,
                record: {
                    access_way_id: null
                },
                errors: []
            }
        },
        metaInfo () {
            return {
                title: trans('create_a_follow_up')
            }
        },
        computed: {
            ...mapGetters({
                'accessWays': 'getActiveAccessWays',
                'member': 'getMember'
            })
        },
        created () {
            let verifyId = window.sessionStorage.getItem('pipeline_card_action_deal_id')
            if (typeof verifyId !== 'undefined' && !isNull(verifyId) && !isNaN(verifyId))
                this.exactDeal = parseInt(verifyId)
        },
        beforeDestroy () {
            window.sessionStorage.removeItem('pipeline_card_action_deal_id')
        },
        mounted () {
            this.record.member_id = this.member.id
        },
        methods: {
            store (redirect) {
                if (this.search === null) {
                    this.errors = { 'deal': [trans('this_field_is_required')] }
                    return
                }

                this.isSaving = true
                this.record.member_id = this.member.id
                this.record.type = 'message'

                create(this.search.id, this.record)
                    .then(response => {
                        if (redirect) {
                            this.$router.push({ name: 'deals.show', params: { id: response.deal_id } })
                        } else {
                            bus.$emit('refreshFollowUpsCard')
                            bus.$emit('refreshDealsCard')
                        }
                        Notify.success(trans('the_record_has_been_saved'))
                        this.clear()
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            clear () {
                this.search = null
                this.isSaving = false
                this.record = {
                    access_way_id: null,
                    member_id: null,
                    type: null
                }
                this.errors = []
                if (!isNull(this.exactDeal))
                    window.sessionStorage.removeItem('pipeline_card_action_deal_id')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/follow-ups/components/Create.vue